module.exports = __webpack_public_path__ + "static/media/jm.2fb1b65b.webp";